// extracted by mini-css-extract-plugin
module.exports = {"validationTip":"_3ZuF_n5","valid":"_2-fD0Ly","error":"_aq1_Rmu"};